// Although this component interacts with the store it seems to stay unchanged from page to page
// so I want to reduce copypaste and reuse it.
// However it works based on the following assumptions
// -- Map of each page contains reusable navigation layer
// -- Byt the time component is rendered there is site information in the store

import * as React from "react";
import { typeCompact14Medium } from "@traceair/tds";
import { style } from "typestyle";
import { connect } from "react-redux";
import config from "../../../config";
import { IGcpAppDispatchProp } from "../../../redux/store";
import { userClicksFitSiteButton } from "./scenarios";

const rootCN = style({
  pointerEvents: "auto",
  cursor: "pointer",
  background: "white",
  padding: "8px 12px",
  borderRadius: "8px",
  boxShadow: "0 1px 2px 0 rgba(0,0,0,0.3)",
  display: "flex",
  alignItems: "center",
  flex: "none",
  $nest: {
    "&>img": {
      marginRight: "12px",
    },
    "&>div": {
      display: "flex",
      alignItems: "center",
    },
  },
});

function FitSiteButton({ dispatch }: IGcpAppDispatchProp) {
  return (
    <div className={rootCN} onClick={() => dispatch(userClicksFitSiteButton())}>
      <img src="icon-fit.svg" />
      <div className={typeCompact14Medium}>
        {config.language === "ru" ? "К площадке" : "Fit Site"}
      </div>
    </div>
  );
}

export default connect()(FitSiteButton);
